import queryString from 'query-string';

const SITE_EVENT_GRAPHQL_FIELDS = {
  site_event_id: 'id',
  phone_md5: 'phoneMd5',
  email_md5: 'emailMd5'
};
const SITE_EVENT_KEYS = Object.keys(SITE_EVENT_GRAPHQL_FIELDS);

export const SITE_EVENT_SELECTION = siteEventSelection();

export default function({ siteEvent, ...data }) {
  dataLayerPush({ ...data, ...siteEventParams(siteEvent) });
}

export function trackServerEvent() {
  const eventJson = document.body.getAttribute('data-track-server-event');
  if (!eventJson) return;
  try {
    const eventData = JSON.parse(eventJson);
    if (eventData instanceof Array) {
      eventData.forEach(data => dataLayerPush(data));
    } else {
      dataLayerPush(eventData);
    }
  } catch (e) {
    if (window.ENV === 'development') {
      throw e;
    }
  }
}

export function trackVirtualPageview() {
  dataLayerPush({
    event: 'virtual_pageview',
    page_path: window.location.href,
    page_title: document.title,
    page_referrer: sessionStorage.getItem('customRef')
  });
  trackCustomRef();
  trackUtmAndExternalReferrer();
}

function siteEventParams(siteEvent) {
  if (!siteEvent) { return {}; }

  return Object.fromEntries(
    SITE_EVENT_KEYS
      .filter(key => siteEvent[key])
      .map(key => [key, siteEvent[key]])
  );
}

function siteEventSelection() {
  const aliases = Object.entries(SITE_EVENT_GRAPHQL_FIELDS)
    .map(([key, field]) => `${key}:${field}`);
  return `siteEvent { ${aliases.join(' ')} }`;
}

function dataLayerPush(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);

  if (window.ENV === 'development') {
    console.log('window.dataLayer.push', data); // eslint-disable-line no-console
  }
}

function trackCustomRef() {
  sessionStorage.setItem('customRef', window.location.href);
}

function trackUtmAndExternalReferrer() {
  const prevUtmValue = sessionStorage.getItem('utmParams');
  const newUtmValue = extractUtmParams();

  const prevExternalReferrer = sessionStorage.getItem('externalReferrer');
  const containsHostname = document.referrer.includes(window.location.hostname) ||
    !document.referrer;
  const newExternalReferrer = containsHostname ? '' : document.referrer;

  const isUtmChanged = newUtmValue != null;
  const isReferrerChanged = prevExternalReferrer == null ||
    (!containsHostname && prevExternalReferrer !== newExternalReferrer);

  if (isUtmChanged || isReferrerChanged) {
    sessionStorage.setItem('utmParams', newUtmValue);
    sessionStorage.setItem('externalReferrer', newExternalReferrer);
  }
}

function extractUtmParams() {
  const queryParams = queryString.parse(window.location.search);
  const utmSource = queryParams.utm_source;
  const utmMedium = queryParams.utm_medium;
  const utmCampaign = queryParams.utm_campaign;
  const utmContent = queryParams.utm_content;
  const utmTerm = queryParams.utm_term;

  return utmSource || utmMedium || utmCampaign || utmContent || utmTerm ?
    [
      `utm_source=${utmSource || ''}`,
      `utm_medium=${utmMedium || ''}`,
      `utm_campaign=${utmCampaign || ''}`,
      `utm_content=${utmContent || ''}`,
      `utm_term=${utmTerm || ''}`
    ].join('&') :
    null;
}
